module.exports = __webpack_public_path__ + "img/placeholder.812a17a9.svg";